import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProtectedRoutes from './ProtectedRoutes';
import ProtectedRoutesAdmin from './ProtectedRoutesAdmin';
import ProtectedRoutesSuperadmin from './ProtectedRoutesSuperadmin';
import { publicRoutes, adminRoutes, getUserRoutes, superadminRoutes } from './app/routes';

function App() {
  const [selectedPaciente, setSelectedPaciente] = React.useState('');
  const userRoutes = getUserRoutes({ selectedPaciente, setSelectedPaciente });

  return (
    <Routes>
      {publicRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}

      <Route element={<ProtectedRoutesAdmin />}>
        {adminRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
      </Route>

      <Route element={<ProtectedRoutesSuperadmin />}>
        {superadminRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
      </Route>

      <Route element={<ProtectedRoutes />}>
        {userRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
      </Route>
    </Routes>
  );
}

export default App;
